
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CTAButtonProps {
  to?: string;
  onClick?: () => void;
  variant?: "default" | "white" | "coral";
  size?: "default" | "lg" | "xl";
  className?: string;
  children: React.ReactNode;
}

const CTAButton: React.FC<CTAButtonProps> = ({
  to,
  onClick,
  variant = "coral",
  size = "xl",
  className = "",
  children
}) => {
  // Render button content directly without memoization
  const buttonContent = (
    <>
      <span>{children}</span>
      <ArrowRight size={20} />
    </>
  );

  // Use className directly without memoization
  const buttonClasses = `inline-flex items-center justify-center ${className}`;

  if (to) {
    return (
      <Link to={to}>
        <Button
          variant={variant}
          size={size}
          className={buttonClasses}
          type="button"
        >
          {buttonContent}
        </Button>
      </Link>
    );
  }

  return (
    <Button
      variant={variant}
      size={size}
      onClick={onClick}
      className={buttonClasses}
      type="button"
    >
      {buttonContent}
    </Button>
  );
};

export default CTAButton;
